<template>
  <div>
    <!-- 底部信息 -->
    <div class="home-footer">
      <div class="home-footer-main">
        <div class="home-footer-main-left">
          <img src="@/assets/home/cn/footer_logo.png" />
        </div>
        <div>
          <template v-if="language == 'en'">
            <img src="@/assets/home/en/qrcode.png" />
          </template>
          <template v-else>
            <img src="@/assets/home/cn/qrcode.png" />
          </template>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
    computed: {
      ...mapGetters(['language', 'info', 'isLogin', 'subjectType', 'fromUrl'])
    },
    data() {
      return {
      }
    }
  }
</script>

<style lang="scss" scoped>
.home-reserve-booth {
  margin-top: 32px;

  .home-reserve-booth-title {
    font-weight: 600;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 24px;
    text-align: center;
    padding: 22px;
    background: linear-gradient(90deg, #00875E 0%, #0068A9 100%);
  }

  .home-reserve-booth-main {
    max-width: 1280px;
    margin: 32px auto;

    img {
      width: 100%;
      margin-bottom: 0px;
    }

    .home-reserve-booth-main-title {
      position: absolute;
      top: 15px;
      right: 0;
      width: 100%;
      text-align: center;
      line-height: 20px;
      font-size: 20px;
      color: #fff;
      font-weight: bold;
    }
  }
}

.home-footer {
  
  width: 100%;
  padding: 27px 0 33px 0;
  background: linear-gradient(90deg, #00875E 0%, #0068A9 100%);

  .home-footer-main {
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      width: 100%;
    }
  }
}

.home-footer-main-left {
  margin-right: 90px;
}

@media (min-width: 320px) and (max-width: 750px) {
  .home-reserve-booth {
    margin-top: 16px;
    .home-reserve-booth-title {
        font-weight: 600;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 12px;
        text-align: center;
        padding: 10px;
        background: linear-gradient(90deg, #00875E 0%, #0068A9 100%);
      }
    
      .home-reserve-booth-main {
        margin: 16px;
    
        img {
          width: 100%;
          margin-bottom: 16px;
        }
    
        .home-reserve-booth-main-title {
          position: absolute;
          top: 5px;
          right: 0;
          width: 100%;
          text-align: center;
          line-height: 20px;
          font-size: 12px;
          color: #fff;
          font-weight: bold;
        }
      }
  }
    .home-footer {
      width: 100%;
      padding: 27px;
      background: linear-gradient(90deg, #00875E 0%, #0068A9 100%);
      .home-footer-main {
        max-width: auto;
        margin: 0 auto;
        display: block;
        img {
          width: 100%;
        }
      }
    }
  
    .home-footer-main-left {
      margin-right: 0px;
    }
}
</style>